<template>
  <h1 class="vehicle-detail__title">{{ carDetail?.make?.name || '' }} {{ carDetail?.model || '' }}</h1>
</template>

<script lang="ts" setup>
  import type { GraphQLCarDetail } from '~/types/graphql';

  const carDetail = inject<GraphQLCarDetail>('carDetail');
</script>

<style lang="scss" scoped>
  .vehicle-detail__title {
    font-family: Chivo;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%; /* 38.4px */
    letter-spacing: -0.32px;

    @screen lg {
      font-family: Chivo;
      font-size: 48px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%; /* 57.6px */
      letter-spacing: -0.48px;
    }
  }
</style>
